<template>
  <div class="home-page">
    <!-- 固定顶部标题栏 -->
    <div class="top-title-bar fixed-top">
      <div class="title-text">音乐计划</div>
    </div>

    

    <!-- 顶部 Banner 区域 -->
    <div class="banner-section">
      <swiper class="banner_swiper" :options="bannerSwiperOption" style="background: unset; height: 180PX;">
        <swiper-slide v-for="(v, key) in banners" :key="key" style="border-radius: 0PX; overflow: hidden;">
          <van-image class="banner_img" :src="`${v.url}`" width="100%" height="180PX">
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
      <div class="dots">
        <span v-for="(v, key) in banners" :key="key" class="dot" :class="{ active: key === 0 }"></span>
      </div>
    </div>
<!-- 顶部公告栏 -->
    <div class="top-notice-bar">
      <div class="notice-tag">
        <img style="width: 20px;height: 20px" src="data:image/png;base64,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" alt="">
      </div>
      <van-notice-bar class="notice-text" color="#333" background="transparent" scrollable :text="notice" />
    </div>
    <!-- 功能图标导航 -->
    <div class="icon-nav">
      <div class="icon-item" @click="$router.push({path:'/Nvai'})">
        <div class="icon-circle" style="background: #f1f8fd;">
          <img src="/img/pai.png" style="width: 40px;height: 40px;border-radius: 5px">
        </div>
        <span class="icon-text">{{ $t("auth.top6") }}</span>
      </div>
      <div class="icon-item" @click="$router.push({path:'/Nanai'})">
        <div class="icon-circle" style="background: #f1f8fd;">
          <img src="/img/logo.png" style="width: 40px;height: 40px;border-radius: 5px">
        </div>
        <span class="icon-text">{{$t("auth.top51")}}</span>
      </div>
      <div class="icon-item" @click="$router.push({path:'/GameRecord'})">
        <div class="icon-circle" style="background: #f1f8fd;">
          <img src="/img/footer/order.png" style="width: 40px;height: 40px;border-radius: 5px">
        </div>
        <span class="icon-text">{{$t("foorter.top23")}}</span>
      </div>
      <div class="icon-item" @click="$router.push({path:'/withdraw'})">
        <div class="icon-circle" style="background: #f1f8fd;">
          <img src="/img/hui.png" style="width: 40px;height: 40px;border-radius: 5px">
        </div>
        <span class="icon-text">{{ $t("withdraw.with_center") }}</span>
      </div>
    </div>

    <!-- 精选好物 -->
    <div class="section-title">
      <span class="slash"></span> {{ $t("foorter.top3") }} <span class="slash"></span>
    </div>

    <!-- 商品列表 -->
    <div class="goods-list">
      <div class="goods-item" v-for="item in datalist" :key="item.id" @click="toDetail(item.key,item.id)">
        <div class="goods-img-box">
          <img :src="item.ico" style="border-radius: 50%;width: 55px;height: 55px">
          <div class="id-badge">{{ item.xuanfei_name }}</div>
        </div>
        <div class="goods-info">
          <div class="goods-name">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <div class="section-title">
      <span class="slash"></span> {{ $t("auth.top32") }} <span class="slash"></span>
    </div>

    <!-- 滚动公告 -->
    <div class="rolling-notice" @mouseenter="pause()" @mouseleave="resume()">
      <div class="scroll-container">
        <ul class="scroll-list" :style="{ transform: `translateY(-${currentIndex * itemHeight}PX)` }">
          <li v-for="(item, index) in displayList" :key="index" style="height: 40PX; line-height: 40PX; text-align: center;font-weight: 700;">
            <span class="highlight">{{ item.name }}</span> {{ $t("auth.top7") }}:{{ item.money }}
          </li>
        </ul>
      </div>
    </div>
    <div style="padding-bottom: 40PX;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      hasToken: false,
      banners: [],
      bannerSwiperOption: {
        loop: true,
        autoplay: true,
        speed: 800,
        pagination: false
      },
      currentIndex: 0,
      timer: null,
      itemHeight: 40,
      listgun: [],
      datalist: []
    };
  },
  computed: {
    displayList() {
      return [...this.listgun, ...this.listgun];
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.notice = res.data.notice;
        this.listgun = res.data.gun;
        this.banners = res.data.banners;
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        url: "lottery_list",
        data: { page: 1, limit: 10 },
      }).then((res) => {
        this.datalist = res.data;
        this.datalist.forEach(item => {
          if (item.flag) {
            const parts = item.flag.split('|');
            const lanng = this.$t("auth.lang");
            lanng == 'zh' ? item.flag = parts[0] : lanng == 'en' ? item.flag = parts[1] : lanng == 'ja' ? item.flag = parts[2] : item.flag = parts[3];
          }
        });
      });
    },
    toDetail(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id });
      }
    },
    startScroll() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.currentIndex++;
        if (this.currentIndex >= this.listgun.length) {
          this.currentIndex = 0;
        }
      }, 1000);
    },
    pause() {
      clearInterval(this.timer);
    },
    resume() {
      this.startScroll();
    }
  },
  mounted() {
    this.startScroll();
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  created() {
    this.getBasicConfig();
    this.getLotteryList();
  }
};
</script>

<style lang="less" scoped>
.home-page {
  min-height: 100VH;
  background: #fff;
  padding-bottom: 60PX;
  padding-top: 50PX; /* 顶部留出固定标题栏高度 */
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.home-page::-webkit-scrollbar {
  display: none;
}

/* 固定顶部标题栏 */
.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

/* 顶部紫色标题栏 */
.top-title-bar {
  width: 100%;
  height: 50PX;
  background: #8600FF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title-text {
  color: #fff;
  font-size: 18PX;
  font-weight: bold;
  letter-spacing: 2PX;
}

/* 顶部公告栏 */
.top-notice-bar {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 10PX 15PX;
  border-bottom: 1PX solid #f0f0f0;
}
.notice-tag {
  color: #fff;
  font-size: 12PX;
  padding: 2PX 8PX;
  border-radius: 4PX;
  margin-right: 10PX;
}
.notice-text {
  flex: 1;
  background: transparent;
  padding: 0;
  font-size: 14PX;
}

/* Banner 区域 */
.banner-section {
  position: relative;
  width: 100%;
}
.banner_swiper {
  width: 100%;
  height: 180PX;
  background: transparent;
}
.banner_img {
  border-radius: 0PX;
}
.dots {
  position: absolute;
  bottom: 10PX;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6PX;
}
.dot {
  width: 6PX;
  height: 6PX;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
}
.dot.active {
  background: #fff;
}

/* 功能图标导航 */
.icon-nav {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: 10PX 5PX;
  background: rgb(124, 77, 255);
  margin: 10PX 10PX;
  border-radius: 12PX;
  border: 2PX solid rgb(124, 77, 255);
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6PX;
  cursor: pointer;
  flex: 1;
  padding: 0PX 0;
  position: relative;
}

.icon-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  width: 2PX;
  height: 60%;
}

.icon-circle {
  width: 50PX;
  height: 50PX;
  border-radius: 10PX;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4PX;
}

.icon-text {
  font-size: 12PX;
  color: #fff;
  text-align: center;
  white-space: nowrap;
}

/* 精选好物标题 */
.section-title {
  text-align: center;
  background: rgb(124, 77, 255);
  margin: 0 10PX;
  font-size: 18PX;
  border-radius: 10PX;
  font-weight: bold;
  color: #fff;
  padding: 15PX 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10PX;
}
.slash {
  color: #fff;
  font-weight: bold;
  font-style: italic;
}

/* 商品列表 */
.goods-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10PX;
  padding: 15PX 10PX;
  margin: 10PX 10PX;
  background: #f9f9f9;
  border-radius: 12PX;
}

/* 商品卡片样式 */
.goods-item {
  background: #fff;
  border-radius: 8PX;
  overflow: hidden;
  cursor: pointer;
  padding: 10PX;
  text-align: center;
  border: 1PX solid #f0f0f0;
  box-shadow: 0 2PX 8PX rgba(0, 0, 0, 0.05);
}

.goods-img-box {
  position: relative;
  width: 100%;
  height: 55PX;
  margin-bottom: 8PX;
  overflow: hidden;
  border-radius: 8PX;
}
.goods-img {
  width: 55PX;
  height: 55PX;
  border-radius: 50%;
}
.id-badge {
  position: absolute;
  top: 4PX;
  left: 4PX;
  color: #fff;
  font-size: 8PX;
  padding: 2PX 5PX;
  border-radius: 4PX;
}

.goods-name {
  font-size: 14PX;
  font-weight: 700;
  color: #333;
  margin-bottom: 4PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 滚动公告 - 视距内显示三条 */
.rolling-notice {
  height: 120PX;
  overflow: hidden;
  background: #fff;
  padding: 0 15PX;
  margin-bottom: 10PX;
}
.scroll-container {
  height: 100%;
  overflow: hidden;
}
.scroll-list {
  transition: transform 0.5s ease;
  list-style: none;
  padding: 0;
  margin: 0;
}
.scroll-list li {
  font-size: 12PX;
  color: #666;
}
.highlight {
  color: #ff5b5b;
  font-weight: bold;
}
:deep .van-image__loading{
  border-radius: 27PX;
}
</style>